import * as actions from './actionsTypes';

const initialData = {
  loading: false,
  orgsLength: 0,
  orgs: [],
}

export default function orgsPruebaReducer(state = initialData, action){
  switch (action.type) {
    case actions.LOADING_ORG:
      return {...state, loading: action.payload}
    case actions.GET_ORG:
      return {...state, orgs: action.payload.orgs, orgsLength: action.payload.orgsLength}
    default:
      return {...state};
  }
}